/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

export type AdminV1OrganizationsPaymentsLogListStatus = typeof AdminV1OrganizationsPaymentsLogListStatus[keyof typeof AdminV1OrganizationsPaymentsLogListStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminV1OrganizationsPaymentsLogListStatus = {
  failed: 'failed',
  paid: 'paid',
  past_due: 'past_due',
  refunded: 'refunded',
  scheduled: 'scheduled',
} as const;
